import React from 'react'
import myobLogo from '../../images/logo-gradient.svg'

export default React.createClass({
  render() {
    return (
      <div id="footerContainer">
        <div id="taxonline-footer-rebranded">
          <nav id="footer-nav" className="navbar-default" role="navigation">
            <div className="container">
              <div className="navbar-header">
                <p><img src={myobLogo} alt="MYOB"/></p>
              </div>
              <ul className="nav navbar-nav navbar-right">
                <li><a href="http://www.myob.com/privacy" target="_blank">Privacy policy</a></li>
                <li><a href="http://www.myob.com/about_myob" target="_blank">About us</a></li>
                <li><a href="http://myob.com/business/support/accountright-support-1257834117279" target="_blank">Support</a></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/app/components/Footer.js